import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { EditReminderDialogModule } from '../../components/edit-reminder-dialog/edit-reminder-dialog.module';

import { MatIconModule } from '@angular/material/icon';
import { DocumentsDialogModule  } from '../../components/documents/documents-dialog.module';

import { EditPatientDialogModule } from '../../components/edit-patient-dialog/edit-patient-dialog.module';
import { EditFamilyDialogModule } from '../../components/edit-family-dialog/edit-family-dialog.module';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { FamilyChecklistView } from './family-checklist-view.component';


@NgModule({
    imports: [
        CommonModule,
        DocumentsDialogModule,
        EditPatientDialogModule,
        EditFamilyDialogModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        EditReminderDialogModule,
        InfiniteScrollModule,
        AvatarModule,
        MatCheckboxModule,
        MatDialogModule,
        MatSortModule,
        MatTableModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        FamilyChecklistView
    ],
    exports: [
        FamilyChecklistView
    ]
})
export class FamilyChecklistViewModule { }
